import script from "./news.vue?vue&type=script&lang=ts&setup=true"
export * from "./news.vue?vue&type=script&lang=ts&setup=true"

import "./news.vue?vue&type=style&index=0&id=c84bdf6c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c84bdf6c"]])

export default __exports__